import { AVATAR_RING_SIZE } from './AvatarRing'
import { SHEET_CELL_H } from './cells/sheetPrimitives'

export type ProductivityDensity = 'compact' | 'standard' | 'comfortable'

export const DEFAULT_PRODUCTIVITY_DENSITY: ProductivityDensity = 'standard'

interface DensityMetrics {
  ringSize: number
  rowHeight: number
}

// A row fits its TALLEST cell — the day block's completion ring, plus the
// identity padding — and never drops below the data-cell floor. Compact buys
// its height back by shrinking the ring rather than clipping it; comfortable
// keeps the ring and spends the extra height on air.
const metricsOf = (ringSize: number, ringPadding: number): DensityMetrics => ({
  ringSize,
  rowHeight: Math.max(SHEET_CELL_H + 8, ringSize + ringPadding),
})

export const DENSITY_METRICS: Record<ProductivityDensity, DensityMetrics> = {
  compact: metricsOf(32, 8),
  standard: metricsOf(AVATAR_RING_SIZE, 12),
  comfortable: metricsOf(AVATAR_RING_SIZE, 24),
}
